const formConditions = {

    "submitConditions" : {

        "rentalAgreement" : (availableAgreements , onlyOneAgreement, formValues ) => {
            if (!onlyOneAgreement) return false
             availableAgreements = Object.entries(availableAgreements)
            .filter(([key]) => !isNaN(key))   // keep only numeric keys
            .flatMap(([_, value]) => value);
            const startDate = new Date(formValues['startDate'])
            const endDate = new Date(formValues['endDate'])
            const startYear = startDate.getFullYear()
            const endYear = endDate.getFullYear()
            var startYearCompleted = false
            var endYearCompleted = false
            for (var agreement of availableAgreements){

                const agreementStartDate = new Date(agreement['startDate'])
                const agreementEndDate = new Date(agreement['endDate'])
                const agreementStartYear = agreementStartDate.getFullYear()
                const agreementEndYear = agreementEndDate.getFullYear()
                if (agreementStartYear < startYear){
                    startYearCompleted = true
                }
                if (agreementEndYear < endYear){
                    endYearCompleted = true
                }
                if (startYearCompleted && endYearCompleted){
                    return false
                }
               if (startDate.getTime() <= agreementEndDate.getTime() &&
                    endDate.getTime() >= agreementStartDate.getTime()) {
                    return true; // they overlap
                }

            }

            return false

        }
    }
}

const formCustomRequestAdditions = {
    "lead" : {
        "include" : {rentals:{select:{id:true,name:true}}}
    },
    rentalAgreement:{
        include : {agreementItems:true}
    }
}

const formCustomRequestNormalizer = {
    "lead" : (value) => {
        const newRentals = []
        const labels = {}
        for (var rental of value.rentals) {
            newRentals.push(rental.id)
            labels[rental.id] = rental.name
        }
        value.rentals = newRentals
        return [value, {
            label:labels
        }]
    }
}


export  {formConditions, formCustomRequestAdditions, formCustomRequestNormalizer}
